<ng-container [ngSwitch]="type">
  <svg
    *ngSwitchCase="'back'"
    height="25"
    width="14"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14.22 24.27"
  >
    <path
      d="M2.12 11.96l9.85-9.84"
      fill="none"
      stroke="#6d6d6d"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="3"
    />
    <path
      d="M2.25 12.31l9.85 9.84"
      fill="none"
      stroke="#6d6d6d"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="3"
    />
  </svg>
  <svg
    *ngSwitchCase="'leftArrow'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 24 24"
  >
    <path stroke="#6d6d6d" stroke-width="2" stroke-linecap="square" d="M10,6 L2,15 L10,22" />
  </svg>
  <svg
    *ngSwitchCase="'rightArrow'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 24 24"
  >
    <path stroke="#6d6d6d" stroke-width="2" stroke-linecap="square" d="M15,2 L22,15 L15,22" />
  </svg>
  <svg
    *ngSwitchCase="'mediumEraser'"
    height="24"
    width="24"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.9 30"
  >
    <path
      d="M13.55,30V22.8L0,19v7.2L13.55,30M29.9,5.45l-15,17v6.7l15-17.45V5.45M14,21.6,29.5,4,17.9,0,.6,17.75Z"
      fill="#6d6d6d"
    />
  </svg>
  <svg
    *ngSwitchCase="'smallEraser'"
    height="18"
    width="18"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.9 30"
  >
    <path
      d="M13.55,30V22.8L0,19v7.2L13.55,30M29.9,5.45l-15,17v6.7l15-17.45V5.45M14,21.6,29.5,4,17.9,0,.6,17.75Z"
      fill="#6d6d6d"
    />
  </svg>
  <svg
    *ngSwitchCase="'tinyEraser'"
    height="14"
    width="14"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.9 30"
  >
    <path
      d="M13.55 30v-7.2L0 19v7.2L13.55 30M29.9 5.45l-15 17v6.7l15-17.45V5.45M14 21.6L29.5 4 17.9 0 .6 17.75z"
      fill="#6d6d6d"
    />
  </svg>
  <svg
    *ngSwitchCase="'line'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 24 24"
  >
    <path
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-width="2"
      stroke-linecap="square"
      d="M21,2 L3,21"
    />
  </svg>
  <svg
    *ngSwitchCase="'circle'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 25 25"
  >
    <circle
      fill="none"
      stroke-width="2"
      [style.stroke]="stroke || '#6d6d6d'"
      cx="13"
      cy="13"
      r="10"
    ></circle>
  </svg>
  <svg
    *ngSwitchCase="'rectangle'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-width="2"
      stroke-linecap="square"
      stroke-miterlimit="3"
      d="M2,2 L22,2 L22,22 L2,22 L2,2"
    ></path>
  </svg>
  <svg
    *ngSwitchCase="'bgElementarySchoolLines'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 21 21"
  >
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="2"
      d="M1 4h20M1 8h20M1 11h20M1 15h20M1 18h20"
    />
  </svg>
  <svg
    *ngSwitchCase="'bgLines'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 21 21"
  >
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-linecap="square"
      stroke-miterlimit="3"
      d="M1 1h20M1 6h20M1 11h20M1 16h20M1 20h20"
    />
  </svg>
  <svg
    *ngSwitchCase="'bgGrid'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 26 26"
  >
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-linecap="square"
      stroke-miterlimit="3"
      d="M26 13h-3v10h3m-3-10V3H13v10zm0-12v2h3M3 1v2h10V1M1 13h2V3H1m2 10v10h10V13zm0 13v-3H1m22 3v-3H13v3"
    />
  </svg>
  <svg
    *ngSwitchCase="'bgAxis'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 25 26"
  >
    <path [style.fill]="fill || '#666666'" d="M18 18v7l7-3-7-4M4 0L1 8h7z" />
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-linecap="square"
      stroke-miterlimit="3"
      d="M5 8v14h13M1 22h4v4"
    />
  </svg>
  <svg
    *ngSwitchCase="'bgWhite'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 26 26"
  >
    <path fill="#fff" d="M1 26h25V1H1z" />
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-linecap="square"
      stroke-miterlimit="1"
      d="M26 26H1V1h25z"
    />
  </svg>
  <svg
    *ngSwitchCase="'bgGray'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 26 26"
  >
    <path fill="#b6b6b6" d="M1 26h25V1H1z" />
    <path
      fill="none"
      [style.stroke]="stroke || '#6d6d6d'"
      stroke-linecap="square"
      stroke-miterlimit="1"
      d="M26 26H1V1h25z"
    />
  </svg>
  <svg *ngSwitchCase="'pencil'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.128 34">
    <path
      [style.fill]="fill || '#6d6d6d'"
      d="M.269 33.803a.721.721 0 00.673.18.683.683 0 00.674-.18l1.481-1.481-1.347-1.351-1.481 1.481A.861.861 0 000 33.08a1.072 1.072 0 00.269.723m2.334-3.86l1.616 1.66 5.3-2.379-4.627-4.626-2.289 5.341m22.216-28.9a.68.68 0 00-.539.269L12.657 12.929a.724.724 0 00-.269.583.815.815 0 00.269.583.735.735 0 00.539.224.894.894 0 00.583-.224L25.45 2.471a.952.952 0 00.224-.628.735.735 0 00-.224-.54.861.861 0 00-.628-.269m8.258 0A3.29 3.29 0 0030.834.003a2.719 2.719 0 00-2.109.808L5.7 23.835l4.668 4.623L33.35 5.478a2.584 2.584 0 00.763-2.2 3.267 3.267 0 00-1.032-2.244m-2.917.314a.444.444 0 01.314.763L8.662 23.925a.444.444 0 11-.628-.628L29.85 1.484a.428.428 0 01.31-.135z"
    />
  </svg>
  <svg
    *ngSwitchCase="'bigEraser'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    preserveAspectRatio="xMidYMin"
  >
    <path
      d="M13.55 30v-7.2L0 19v7.2L13.55 30M29.9 5.45l-15 17v6.7l15-17.45V5.45M14 21.6L29.5 4 17.9 0 .6 17.75z"
      [style.fill]="fill || '#6d6d6d'"
    />
  </svg>
  <svg
    *ngSwitchCase="'figures'"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
  >
    <path
      d="M20.8 12a11.45 11.45 0 00-8.6-3.6 5.76 5.76 0 00-1.3.15A11.15 11.15 0 003.6 12 11.94 11.94 0 000 20.75a11.88 11.88 0 003.55 8.65A11.75 11.75 0 0012.2 33a11.53 11.53 0 008.6-3.6 11.71 11.71 0 003.65-8.65 9.44 9.44 0 00-.2-2A11.89 11.89 0 0020.8 12m-10-12v6.35a10.25 10.25 0 011.45-.1 13.52 13.52 0 0110.2 4.3h-.1a13.8 13.8 0 014.1 7.9.2.2 0 00.1.15h9.85V0z"
      [style.fill]="fill || '#6d6d6d'"
    />
  </svg>
  <svg
    *ngSwitchCase="'text'"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 33"
  >
    <path d="M0 33h33V0H0z" fill="#fff" />
    <path
      d="M25.7 10.7l-.25-5.1H7.6l-.25 5.1H8a4.78 4.78 0 01.7-2.35 3 3 0 011.4-1.15 6.78 6.78 0 012.2-.2h2.6v16.7a4.88 4.88 0 01-.35 2.3 2.22 2.22 0 01-2 .85h-.8v.6H21v-.6h-.8a2.4 2.4 0 01-1.85-.65 4.44 4.44 0 01-.4-2.55V7h3.1a4.39 4.39 0 012.15.45 3.23 3.23 0 011.4 1.35 5.61 5.61 0 01.4 1.9z"
      [style.fill]="fill || '#6d6d6d'"
    />
  </svg>
  <svg
    *ngSwitchCase="'eye'"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 40 35"
  >
    <path
      [style.fill]="fill || '#6d6d6d'"
      d="M22.653 13.01a5.12 5.12 0 00-3.786-.579 4.915 4.915 0 00-3.163 2.316 5.139 5.139 0 001.782 6.948 5.185 5.185 0 006.9-1.782 4.064 4.064 0 00.624-1.826 4.2 4.2 0 00-.045-1.781l-4.9 1.024 3.474-3.652a7.5 7.5 0 00-.891-.668m6.771 4.32a10.092 10.092 0 00-.178-1.915l-2.183.445a7.985 7.985 0 01.134 1.47 6.913 6.913 0 01-2.094 5.077 7.1 7.1 0 01-10.156 0 6.913 6.913 0 01-2.094-5.077 7.009 7.009 0 012.094-5.077 7.209 7.209 0 0110.067-.089l1.559-1.6a9.472 9.472 0 00-13.1 0 .517.517 0 00-.089.134 9.407 9.407 0 000 13.317.518.518 0 01.089.134 9.417 9.417 0 0013.051 0l.134-.134a9.1 9.1 0 002.771-6.69z"
    />
    <path
      [style.fill]="fill || '#6d6d6d'"
      d="M27.07 7.753a20.439 20.439 0 00-14.17 0 27.171 27.171 0 00-6.89 3.712 32.189 32.189 0 00-3.883 3.362 16.378 16.378 0 00-1.458 1.611l-.67.867.683.862a16.07 16.07 0 001.453 1.611 32.457 32.457 0 003.887 3.362 26.809 26.809 0 006.89 3.716 20.426 20.426 0 0014.166 0 27.171 27.171 0 006.89-3.712 32.643 32.643 0 003.883-3.362 21.116 21.116 0 001.458-1.611l.679-.867-.694-.862a16.069 16.069 0 00-1.453-1.611 32.459 32.459 0 00-3.887-3.362 26.833 26.833 0 00-6.886-3.716m5.17 5.923a28.673 28.673 0 014.1 3.633 28.673 28.673 0 01-4.1 3.633 24.4 24.4 0 01-5.73 3.152 9.407 9.407 0 01-13.041-.009 24.037 24.037 0 01-5.726-3.147 28.672 28.672 0 01-4.1-3.633 28.672 28.672 0 014.1-3.633 24.273 24.273 0 015.726-3.143 9.411 9.411 0 0113.058 0 23.875 23.875 0 015.715 3.146z"
    />
  </svg>
  <svg
    *ngSwitchCase="'eyeDisabled'"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 40 35"
  >
    <path
      fill="#6d6d6d"
      d="M22.653 13.01a5.12 5.12 0 00-3.786-.579 4.915 4.915 0 00-3.163 2.316 5.139 5.139 0 001.782 6.948 5.185 5.185 0 006.9-1.782 4.064 4.064 0 00.624-1.826 4.2 4.2 0 00-.045-1.781l-4.9 1.024 3.474-3.652a7.5 7.5 0 00-.891-.668m6.771 4.32a10.092 10.092 0 00-.178-1.915l-2.183.445a7.985 7.985 0 01.134 1.47 6.913 6.913 0 01-2.094 5.077 7.1 7.1 0 01-10.156 0 6.913 6.913 0 01-2.094-5.077 7.009 7.009 0 012.094-5.077 7.209 7.209 0 0110.067-.089l1.559-1.6a9.472 9.472 0 00-13.1 0 .517.517 0 00-.089.134 9.407 9.407 0 000 13.317.518.518 0 01.089.134 9.417 9.417 0 0013.051 0l.134-.134a9.1 9.1 0 002.771-6.69z"
    />
    <path
      fill="#6d6d6d"
      d="M27.07 7.753a20.439 20.439 0 00-14.17 0 27.171 27.171 0 00-6.89 3.712 32.189 32.189 0 00-3.883 3.362 16.378 16.378 0 00-1.458 1.611l-.67.867.683.862a16.07 16.07 0 001.453 1.611 32.457 32.457 0 003.887 3.362 26.809 26.809 0 006.89 3.716 20.426 20.426 0 0014.166 0 27.171 27.171 0 006.89-3.712 32.643 32.643 0 003.883-3.362 21.116 21.116 0 001.458-1.611l.679-.867-.694-.862a16.069 16.069 0 00-1.453-1.611 32.459 32.459 0 00-3.887-3.362 26.833 26.833 0 00-6.886-3.716m5.17 5.923a28.673 28.673 0 014.1 3.633 28.673 28.673 0 01-4.1 3.633 24.4 24.4 0 01-5.73 3.152 9.407 9.407 0 01-13.041-.009 24.037 24.037 0 01-5.726-3.147 28.672 28.672 0 01-4.1-3.633 28.672 28.672 0 014.1-3.633 24.273 24.273 0 015.726-3.143 9.411 9.411 0 0113.058 0 23.875 23.875 0 015.715 3.146z"
    />
    <path
      fill="none"
      stroke="#6d6d6d"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="4"
      d="M5.501 2.828l28.954 28.949"
    />
  </svg>
  <svg
    *ngSwitchCase="'bg'"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 33 33"
  >
    <path fill="#fff" d="M33 0H0v33h33z" />
    <path
      [style.fill]="fill || '#6d6d6d'"
      d="M1.45 10h2.8l.15 19h19v2.7l7.6-3.2-7.6-3.4v3h-18L5.25 10H8L4.75 2.6 1.45 10M18.9 4.55h-7.35V2.2h-1v2.35H8.1v1h2.45V13H8.1v1h2.45v7.3H8.1v1h2.45v2.1h1v-2.1h7.35v2.1h1v-2.1h7.35v2.1h1v-2.1h2.35v-1h-2.35V14h2.35v-1h-2.35V5.55h2.35v-1h-2.35V2.2h-1v2.35H19.9V2.2h-1v2.35m-7.35 1h7.35V13h-7.35V5.55M18.9 14v7.3h-7.35V14h7.35m1-8.4h7.35V13H19.9V5.55m7.35 15.7H19.9V14h7.35z"
    />
  </svg>
  <svg
    *ngSwitchCase="'minimizeArrow'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="28"
    height="28"
    preserveAspectRatio="xMidYMin"
  >
    <defs>
      <path
        id="a"
        fill="#6D6D6D"
        d="M656 576q0-7-4-12-5-5-12-5t-12 5q-5 5-5 12t5 12q5 4 12 4t12-4q4-5 4-12z"
      />
      <path
        id="b"
        fill="#B6B6B6"
        d="M656 576q0-7-4-12-5-5-12-5t-12 5q-5 5-5 12t5 12q5 4 12 4t12-4q4-5 4-12z"
      />
      <path id="c" fill="#FFF" d="M635 570l4-4-11-2 2 11 4-4 7 8 1-2-7-7z" />
    </defs>
    <use transform="translate(-463 -414) scale(.74623)" xlink:href="#a" />
    <use transform="translate(-464 -417) scale(.74623)" xlink:href="#b" />
    <use transform="translate(-622 -559)" xlink:href="#c" />
  </svg>
  <svg
    *ngSwitchCase="'backArrow'"
    height="25"
    width="14"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14.22 24.27"
  >
    <path
      d="M2.12 11.96l9.85-9.84"
      fill="none"
      stroke="#6d6d6d"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="3"
    />
    <path
      d="M2.25 12.31l9.85 9.84"
      fill="none"
      stroke="#6d6d6d"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="3"
    />
  </svg>
  <svg
    *ngSwitchCase="'trashbin'"
    height="27"
    width="27"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 27.4"
  >
    <path
      d="M20,8.3H0L2.9,27.7H17.15L20,8.3M4,12.5a.87.87,0,0,1,.25-.75.8.8,0,0,1,.65-.4.94.94,0,0,1,.75.25.84.84,0,0,1,.35.65L7.4,24.2a1,1,0,0,1-.2.75,1,1,0,0,1-.65.35,1,1,0,0,1-.75-.2.91.91,0,0,1-.4-.65L4,12.5m11.55-1.15a.91.91,0,0,1,.65.4,1,1,0,0,1,.2.75L15,24.45a1,1,0,0,1-.35.65,1,1,0,0,1-.75.2.84.84,0,0,1-.65-.35A.94.94,0,0,1,13,24.2l1.4-11.95a.8.8,0,0,1,.4-.65.87.87,0,0,1,.75-.25m-4.85.25a1,1,0,0,1,.3.7v12a1,1,0,0,1-2,0v-12a1,1,0,0,1,1.7-.7M13,.3H7V3H.6L0,6.2H20L19.4,3H13Z"
      transform="translate(0 -0.3)"
      fill="#6d6d6d"
    />
  </svg>
  <svg
    *ngSwitchCase="'fontBigger'"
    height="20"
    width="40"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 39.8 20"
  >
    <path
      d="M19.9,10a9.6,9.6,0,0,0,2.9,7.05A9.68,9.68,0,0,0,29.9,20,9.52,9.52,0,0,0,37,17.05,9.52,9.52,0,0,0,39.9,10,9.68,9.68,0,0,0,37,2.9,9.6,9.6,0,0,0,29.9,0a9.9,9.9,0,0,0-10,10Z"
      transform="translate(-0.1 0)"
      fill="#6d6d6d"
    />
    <path
      d="M31.15,5.1h-2.5V8.75H25v2.5h3.65v3.7h2.5v-3.7h3.7V8.75h-3.7Z"
      transform="translate(-0.1 0)"
      fill="#fff"
    />
    <path
      d="M9.6,1H9.2L3,15.5a7.09,7.09,0,0,1-1.5,2.55,2.91,2.91,0,0,1-1.4.5V19H5.65v-.45A3.28,3.28,0,0,1,4,18.15a.86.86,0,0,1-.4-.7,4.52,4.52,0,0,1,.45-1.55l1.2-2.75h6.8l1,2.5a5.69,5.69,0,0,1,.5,1.8,1,1,0,0,1-.35.75,2.47,2.47,0,0,1-1.4.35V19h7v-.45a2.61,2.61,0,0,1-1.7-.6,6.46,6.46,0,0,1-1.35-2.3L9.6,1m2,11.15h-6L8.7,5.05Z"
      transform="translate(-0.1 0)"
      fill="#6d6d6d"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    *ngSwitchCase="'fontSmaller'"
    height="20"
    width="33"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
    viewBox="0 0 33 20"
  >
    <path
      d="M36.5,10a9.68,9.68,0,0,0-2.95-7.1A9.6,9.6,0,0,0,26.5,0a9.9,9.9,0,0,0-10,10,9.6,9.6,0,0,0,2.9,7.05A9.68,9.68,0,0,0,26.5,20a9.52,9.52,0,0,0,7.05-2.95A9.52,9.52,0,0,0,36.5,10Z"
      transform="translate(-3.5 0)"
      fill="#6d6d6d"
    />
    <path d="M21.6,8.75v2.5h9.85V8.75Z" transform="translate(-3.5 0)" fill="#fff" />
    <path
      d="M9.2,4.6H9L5.2,13.3a4.79,4.79,0,0,1-.85,1.55,2.14,2.14,0,0,1-.85.25v.3H6.8v-.3a2.1,2.1,0,0,1-1-.2q-.3-.2-.3-.4a2.65,2.65,0,0,1,.3-.95l.7-1.65h4.1l.65,1.5a3.41,3.41,0,0,1,.3,1.1.57.57,0,0,1-.25.45,1.45,1.45,0,0,1-.8.15v.3H14.7v-.3a1.71,1.71,0,0,1-1-.3,4.26,4.26,0,0,1-.75-1.4L9.2,4.6m1.25,6.7H6.8L8.65,7.05Z"
      transform="translate(-3.5 0)"
      fill="#6d6d6d"
    />
  </svg>
  <svg
    *ngSwitchCase="'colorPicker'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31.156 31.156"
    preserveAspectRatio="xMidYMin"
  >
    <path
      fill="#6d6d6d"
      d="M23.865 3.935a4.172 4.172 0 00-2.708 1.273l-1.76 1.759a4.77 4.77 0 00-.51.602l-.532-.533a2.587 2.587 0 00-1.9-.788 2.587 2.587 0 00-1.899.788 2.587 2.587 0 00-.787 1.9 2.587 2.587 0 00.787 1.899l.278.278L4.766 21.737a3.177 3.177 0 00-.95 2.338 3.122 3.122 0 00.951 2.29l.024.024a3.122 3.122 0 002.29.949 3.3 3.3 0 002.362-.926l10.624-10.068.254.254a2.587 2.587 0 001.9.788 2.587 2.587 0 001.9-.788 2.587 2.587 0 00.787-1.899 2.587 2.587 0 00-.788-1.9l-.51-.508a4.772 4.772 0 00.603-.51l1.758-1.759a4.256 4.256 0 001.296-2.685 3.1 3.1 0 00-.88-2.545 3 3 0 00-2.522-.857m-8.102 8.101l3.38 3.38L8.54 25.46a2.079 2.079 0 01-1.458.579 1.868 1.868 0 01-1.365-.58l-.024-.023a1.868 1.868 0 01-.579-1.365 1.959 1.959 0 01.602-1.435z"
    />
  </svg>
  <svg
    *ngSwitchCase="'cog'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
    preserveAspectRatio="xMidYMin"
  >
    <path
      [style.fill]="fill || '#6d6d6d'"
      d="M9.082 2.639L7.916 1.228 5.093 2.885l.736 1.718q-.368.307-.736.675l-.675.675L2.7 5.278.982 8.101l1.534 1.227a9.722 9.722 0 00-.614 2.332l-1.9.307v3.252l1.9.246a10.9 10.9 0 00.675 2.516l-1.534 1.227L2.7 21.969l1.964-.736a6.111 6.111 0 00.429.491q.43.43.859.8l-.736 1.841 2.761 1.657 1.289-1.534a10.805 10.805 0 002.393.614l.307 1.9h3.191l.307-1.9a12.621 12.621 0 002.209-.675l1.35 1.6 2.884-1.657-.859-1.964a3.162 3.162 0 00.614-.675q.369-.307.675-.614l1.9.8 1.718-2.823-1.6-1.227a18.3 18.3 0 00.675-2.455l1.964-.368v-3.191l-1.964-.245a10.642 10.642 0 00-.675-2.27l1.473-1.227-1.6-2.823-1.841.675q-.368-.368-.736-.675a4.328 4.328 0 00-.614-.614l.675-1.9-2.761-1.534-1.227 1.411a8.994 8.994 0 00-2.332-.675L15.024.012h-3.252l-.246 1.964a9.9 9.9 0 00-2.454.675m4.234 3.743a7.228 7.228 0 017.241 7.179 6.76 6.76 0 01-2.148 5.032 6.929 6.929 0 01-5.093 2.086 6.857 6.857 0 01-5.032-2.086 6.963 6.963 0 01-2.025-5.032A7.174 7.174 0 018.274 8.48a6.857 6.857 0 015.032-2.086m4.357 2.761a5.733 5.733 0 00-4.234-1.657 6.157 6.157 0 00-4.357 1.657 6.136 6.136 0 004.357 10.493 5.529 5.529 0 004.234-1.779 6.223 6.223 0 000-8.714m-4.234-.92a4.892 4.892 0 013.682 1.534 5 5 0 011.6 3.743 5.457 5.457 0 01-5.277 5.277 5.194 5.194 0 01-3.8-1.6 5 5 0 01-1.473-3.682 5.2 5.2 0 011.473-3.743 5.3 5.3 0 013.805-1.541z"
    />
  </svg>
  <svg
    *ngSwitchCase="'save'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.026 28.026"
    preserveAspectRatio="xMidYMin"
  >
    <path
      [style.fill]="fill || '#666666'"
      d="M6.95 20.9v2.071h11.942V20.9H6.95m0 3.777v3.351h11.942v-3.351H6.95m0-8.1v2.681h11.942v-2.681a1.048 1.048 0 00-.244-.67.891.891 0 00-.548-.183H7.8a1.176 1.176 0 00-.609.183 1.049 1.049 0 00-.244.67m.244-9.017a.878.878 0 00.609.3h10.3a.7.7 0 00.548-.3.641.641 0 00.244-.548V0H6.95v7.007a.642.642 0 00.244.548M2.503 0a2.5 2.5 0 00-2.5 2.5v23.091a2.337 2.337 0 00.731 1.706 2.407 2.407 0 001.767.731h2.863V16.572a2.407 2.407 0 01.731-1.767 2.53 2.53 0 01.792-.548 2.3 2.3 0 01.914-.183h10.3a2.338 2.338 0 011.706.731 2.407 2.407 0 01.731 1.767v11.454h5.057a2.5 2.5 0 002.437-2.437V6.946q-.061-.244-.122-.426-.061-.061-.731-.67-2.254-2.315-5.605-5.605a.392.392 0 00-.244-.183.541.541 0 00-.244-.061h-.548v7.007a2.706 2.706 0 01-.122.853 4.486 4.486 0 01-.609.914 2.338 2.338 0 01-1.706.731h-10.3a2.211 2.211 0 01-1.706-.731 2.407 2.407 0 01-.731-1.767V0z"
    />
  </svg>
  <svg *ngSwitchCase="'polygon1'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 26">
    <g id="Polygon1" fill="none">
      <path d="M15.262 0l15.261 26H.001z" />
      <path
        [style.fill]="fill || '#707070'"
        d="M15.262 3.951L3.494 24H27.03L15.262 3.951m0-3.951l15.26 26H.002l15.26-26z"
      />
    </g>
  </svg>
  <svg *ngSwitchCase="'polygon2'" xmlns="http://www.w3.org/2000/svg" viewBox="-6.5 0 31 26">
    <g id="Polygon2" fill="none" [style.stroke]="stroke || '#707070'" stroke-width="2">
      <path d="M1 .121v26" data-name="Line 45" />
      <path d="M1 25.121h20" data-name="Line 46" />
      <path d="M1 .621l19 24" data-name="Line 47" />
    </g>
  </svg>
  <svg *ngSwitchCase="'transparent'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.137 25">
    <g data-name="Group 607">
      <g data-name="Group 602">
        <path fill="#fff" d="M.093 0h5v5h-5z" />
        <path fill="#fff" d="M10.137 0h5v5h-5z" />
        <path fill="#fff" d="M20.137 0h5v5h-5z" />
        <path fill="#d4d4d4" d="M5.094 0h5v5h-5z" />
        <path fill="#d4d4d4" d="M15.18 0h5v5h-5z" />
      </g>
      <g>
        <path fill="#fff" d="M.046 10h5v5h-5z" />
        <path fill="#fff" d="M10.09 10h5v5h-5z" />
        <path fill="#fff" d="M20.09 10h5v5h-5z" />
        <path fill="#d4d4d4" d="M5.047 10h5v5h-5z" />
        <path fill="#d4d4d4" d="M15.133 10h5v5h-5z" />
      </g>
      <g>
        <path fill="#fff" d="M0 20h5v5H0z" />
        <path fill="#fff" d="M10.044 20h5v5h-5z" />
        <path fill="#fff" d="M20.044 20h5v5h-5z" />
        <path fill="#d4d4d4" d="M5.001 20h5v5h-5z" />
        <path fill="#d4d4d4" d="M15.087 20h5v5h-5z" />
      </g>
      <g>
        <path fill="#d4d4d4" d="M.046 5h5v5h-5z" />
        <path fill="#d4d4d4" d="M10.09 5h5v5h-5z" />
        <path fill="#d4d4d4" d="M20.09 5h5v5h-5z" />
        <path fill="#fff" d="M5.047 5h5v5h-5z" />
        <path fill="#fff" d="M15.133 5h5v5h-5z" />
      </g>
      <g>
        <path fill="#d4d4d4" d="M0 15h5v5H0z" />
        <path fill="#d4d4d4" d="M10.044 15h5v5h-5z" />
        <path fill="#d4d4d4" d="M20.044 15h5v5h-5z" />
        <path fill="#fff" d="M5.001 15h5v5h-5z" />
        <path fill="#fff" d="M15.087 15h5v5h-5z" />
      </g>
    </g>
  </svg>
  <svg *ngSwitchCase="'semiTransparent'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.137 25">
    <defs />
    <g>
      <path fill="#bcbcbc" d="M.093 0h5v5h-5z" />
      <path fill="#bcbcbc" d="M10.137 0h5v5h-5z" />
      <path fill="#bcbcbc" d="M20.137 0h5v5h-5z" />
      <path fill="#919191" d="M5.094 0h5v5h-5z" />
      <path fill="#919191" d="M15.18 0h5v5h-5z" />
      <path fill="#bcbcbc" d="M.047 10h5v5h-5z" />
      <path fill="#bcbcbc" d="M10.09 10h5v5h-5z" />
      <path fill="#bcbcbc" d="M20.09 10h5v5h-5z" />
      <path fill="#919191" d="M5.047 10h5v5h-5z" />
      <path fill="#919191" d="M15.134 10h5v5h-5z" />
      <path fill="#bcbcbc" d="M0 20h5v5H0z" />
      <path fill="#bcbcbc" d="M10.044 20h5v5h-5z" />
      <path fill="#bcbcbc" d="M20.044 20h5v5h-5z" />
      <path fill="#919191" d="M5 20h5v5H5z" />
      <path fill="#919191" d="M15.087 20h5v5h-5z" />
      <path fill="#919191" d="M.047 5h5v5h-5z" />
      <path fill="#919191" d="M10.09 5h5v5h-5z" />
      <path fill="#919191" d="M20.09 5h5v5h-5z" />
      <path fill="#bcbcbc" d="M5.047 5h5v5h-5z" />
      <path fill="#bcbcbc" d="M15.134 5h5v5h-5z" />
      <path fill="#919191" d="M0 15h5v5H0z" />
      <path fill="#919191" d="M10.044 15h5v5h-5z" />
      <path fill="#919191" d="M20.044 15h5v5h-5z" />
      <path fill="#bcbcbc" d="M5 15h5v5H5z" />
      <path fill="#bcbcbc" d="M15.087 15h5v5h-5z" />
    </g>
  </svg>
  <svg *ngSwitchCase="'opaque'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
    <path fill="#636363" d="M0 0h25v25H0z" />
  </svg>
  <svg *ngSwitchCase="'thinLine'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 2">
    <path fill="none" stroke="#000" stroke-width="2" d="M0 1h30" />
  </svg>
  <svg *ngSwitchCase="'normalLine'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 5">
    <path fill="none" stroke="#000" stroke-width="5" d="M0 2.5h30" />
  </svg>
  <svg *ngSwitchCase="'thickLine'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 10">
    <path fill="none" stroke="#000" stroke-width="10" d="M0 5h30" />
  </svg>
  <svg
    *ngSwitchCase="'videoPlayer'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.7 23.05"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
  >
    <path
      data-name="Path 256"
      d="M28.7 5.8q0-5.8-5.8-5.8H5.8Q0 0 0 5.8v11.45q0 5.8 5.8 5.8h17.1q5.8 0 5.8-5.8V5.8m-5.8-3.3q3.3 0 3.3 3.3v11.45q0 3.3-3.3 3.3H5.8q-3.3 0-3.3-3.3V5.8q0-3.3 3.3-3.3h17.1m-3.4 9.1L11.2 6v11z"
      fill="#4b4b4b"
    />
  </svg>
  <svg
    *ngSwitchCase="'audioPlayer'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.7 23.05"
    pointer-events="visible"
    preserveAspectRatio="xMidYMin"
  >
    <path
      data-name="Path 254"
      d="M28.7 5.8q0-5.8-5.8-5.8H5.8Q0 0 0 5.8v11.45q0 5.8 5.8 5.8h17.1q5.8 0 5.8-5.8V5.8m-5.8-3.3q3.3 0 3.3 3.3v11.45q0 3.3-3.3 3.3H5.8q-3.3 0-3.3-3.3V5.8q0-3.3 3.3-3.3h17.1M10.6 16.2a2.824 2.824 0 00-1.55.65 1.372 1.372 0 00-.65 1.05q0 .55.65.75a2.4 2.4 0 001.55.1 3.46 3.46 0 001.6-.65 1.694 1.694 0 00.65-.95v-7l6.1-2.5v5.9a2.4 2.4 0 00-1.55-.1 3.46 3.46 0 00-1.6.65 1.482 1.482 0 00-.65 1.05.848.848 0 00.65.8 3.105 3.105 0 001.6.1 3.417 3.417 0 001.55-.65 1.576 1.576 0 00.65-.95V4l-7.4 2.95v9.3a2.345 2.345 0 00-1.6-.05m8.35-10.6v.75l-6.1 2.45v-.75z"
      fill="#4b4b4b"
    />
  </svg>
  <svg
    *ngSwitchCase="'clearAll'"
    xmlns="http://www.w3.org/2000/svg"
    width="37.4"
    height="32.6"
    viewBox="0 0 37 33"
  >
    <path fill="#6d6d6d" d="M0 24v6l11 3v-6L0 24m24-6v-5L12 27v5l12-14m0-6L14 9 0 23l11 3z" />
    <path
      fill="#6d6d6d"
      d="M21 18h2l4-5h-2l-4 5m11-2l-1-1h-5v1h6m4 2l-3-5h-2l3 5h2M27 0v1h3V0h-3m-5 2a2 2 0 00-2 2v6a2 2 0 002 2h13a2 2 0 002-2V4a2 2 0 00-2-2H22m0 2a1 1 0 011-1h12a1 1 0 011 1v6a1 1 0 01-1 1H23a1 1 0 01-1-1z"
    />
  </svg>

  <svg
    *ngSwitchCase="'showAllExample'"
    xmlns="http://www.w3.org/2000/svg"
    width="29.682"
    height="29.59"
  >
    <path
      d="M18 5.793H0v18h18v-18M2.38 8.223h13.23v13.185H2.38V8.223m13.23 0H2.38v13.185h13.23z"
      fill="#6d6d6d"
    />
    <path d="M15.467 8.305h-13v13h13z" fill="#d7d7d7" />
    <path d="M29.68 0h-7.011v6.99h7.011z" fill="#6d6d6d" />
    <path d="M29.68 11.301h-7.011v6.99h7.011z" fill="#6d6d6d" />
    <path d="M29.68 22.601h-7.011v6.99h7.011z" fill="#6d6d6d" />
    <path d="M27.23 16.293v-3h-10.9v3z" fill="#6d6d6d" />
    <path
      d="M16.73 14.843v4.25l6.35 6.35 2.1-2.1-8.45-8.5m8.45-8.55l-2.1-2.15-6.35 6.35v4.25z"
      fill="#6d6d6d"
    />
  </svg>

  <svg
    *ngSwitchCase="'showOnlyOneExample'"
    xmlns="http://www.w3.org/2000/svg"
    width="29.682"
    height="29.59"
  >
    <path
      d="M18 5.792H0v18h18v-18M2.38 8.222h13.23v13.185H2.38V8.222m13.23 0H2.38v13.185h13.23z"
      fill="#6d6d6d"
    />
    <path
      d="M11.16 9.752h-1.8l-3.285 2.61 1.08 1.26 1.125-.9q.225-.18.765-.72L9 20.012h2.16z"
      fill="#d7d7d7"
    />
    <path d="M29.68 0h-7.011v6.99h7.011z" fill="#6d6d6d" />
    <path d="M29.68 11.3h-7.011v6.99h7.011z" fill="#6d6d6d" />
    <path d="M29.68 22.6h-7.011v6.99h7.011z" fill="#6d6d6d" />
    <path
      d="M16.68 14.792h9.05"
      fill="none"
      stroke="#6d6d6d"
      stroke-linecap="square"
      stroke-miterlimit="3"
      stroke-width="3"
    />
  </svg>

  <svg *ngSwitchCase="'showAnswer'" xmlns="http://www.w3.org/2000/svg" width="18.999" height="20.7">
    <path d="M18.999 1.05L17.299 0l-7.85 13.1-4.25-5.4-1.55 1.25 6 7.65z" fill="#6d6d6d" />
    <path d="M11.65 2.9H0v17.8h17.8V8.55h-2V18.7H2V4.9h9.65z" fill="#6d6d6d" />
  </svg>

  <svg *ngSwitchCase="'showTip'" xmlns="http://www.w3.org/2000/svg" width="26.096" height="24.02">
    <path
      data-name="Path 353"
      d="M26.096 4.42l-1.7-1.05-7.85 13.05-4.2-5.35-1.55 1.25 5.95 7.6z"
      fill="#6d6d6d"
    />
    <path
      data-name="Path 354"
      d="M18.746 8.22v-2H7.096v17.8h17.8V11.87h-2v10.15h-13.8V8.22z"
      fill="#6d6d6d"
    />
    <path
      data-name="Path 355"
      d="M2.336 2.336A8 8 0 108 0a7.712 7.712 0 00-5.664 2.336m.9 10.431a6.76 6.76 0 114.768 1.952 6.486 6.486 0 01-4.772-1.951z"
      fill="#6d6d6d"
    />
    <path
      data-name="Path 356"
      d="M1.28 8a6.665 6.665 0 101.952-4.768A6.486 6.486 0 001.28 8z"
      fill="#d7d7d7"
    />
    <path
      data-name="Path 357"
      d="M7.328 11.712a.774.774 0 00-.16.512.724.724 0 00.16.48.866.866 0 001.088 0 .724.724 0 00.16-.48.774.774 0 00-.16-.512.867.867 0 00-1.088 0m-1.216-7.9a2.232 2.232 0 00-.768 1.7H6.56a1.156 1.156 0 01.416-.928 1.627 1.627 0 011.088-.352 1.319 1.319 0 011.024.384 1.427 1.427 0 01.384 1.056 1.971 1.971 0 01-.544 1.344l-.864.9a3.012 3.012 0 00-.672.992 4.375 4.375 0 00-.192 1.248h1.216a2.246 2.246 0 01.48-1.536l.7-.7a3.29 3.29 0 001.088-2.272 2.4 2.4 0 00-.7-1.824 2.666 2.666 0 00-1.92-.672 2.782 2.782 0 00-1.952.656z"
      fill="#6d6d6d"
    />
  </svg>

  <svg *ngSwitchCase="'penSettings'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <defs>
      <g id="Layer0_0_MEMBER_0_FILL">
        <path
          stroke="none"
          [style.fill]="fill || '#6d6d6d'"
          d="
M 1243.2 686.25
L 1242.25 685.1 1239.95 686.45 1240.55 687.85
Q 1240.25 688.1 1239.95 688.4 1239.7 688.65 1239.4 688.95
L 1238 688.4 1236.6 690.7 1237.85 691.7
Q 1237.5 692.55 1237.35 693.6
L 1235.8 693.85 1235.8 696.5 1237.35 696.7
Q 1237.5 697.75 1237.9 698.75
L 1236.65 699.75 1238 702 1239.6 701.4
Q 1239.8 701.65 1239.95 701.8 1240.3 702.15 1240.65 702.45
L 1240.05 703.95 1242.3 705.3 1243.35 704.05
Q 1244.25 704.4 1245.3 704.55
L 1245.55 706.1 1248.15 706.1 1248.4 704.55
Q 1249.35 704.35 1250.2 704
L 1251.3 705.3 1253.65 703.95 1252.95 702.35
Q 1253.25 702.1 1253.45 701.8 1253.75 701.55 1254 701.3
L 1255.55 701.95 1256.95 699.65 1255.65 698.65
Q 1256 697.65 1256.2 696.65
L 1257.8 696.35 1257.8 693.75 1256.2 693.55
Q 1256 692.5 1255.65 691.7
L 1256.85 690.7 1255.55 688.4 1254.05 688.95
Q 1253.75 688.65 1253.45 688.4 1253.25 688.15 1252.95 687.9
L 1253.5 686.35 1251.25 685.1 1250.25 686.25
Q 1249.35 685.85 1248.35 685.7
L 1248.05 684.1 1245.4 684.1 1245.2 685.7
Q 1244.15 685.85 1243.2 686.25
M 1246.65 689.3
Q 1249.1 689.3 1250.8 691 1252.55 692.75 1252.55 695.15 1252.55 697.55 1250.8 699.25 1249.1 700.95 1246.65 700.95 1244.25 700.95 1242.55 699.25 1240.9 697.55 1240.9 695.15 1240.9 692.75 1242.55 691 1244.25 689.3 1246.65 689.3
M 1250.2 691.55
Q 1248.85 690.2 1246.75 690.2 1244.65 690.2 1243.2 691.55 1241.75 693 1241.75 695.1 1241.75 697.2 1243.2 698.65 1244.65 700.1 1246.75 700.1 1248.85 700.1 1250.2 698.65 1251.65 697.2 1251.65 695.1 1251.65 693 1250.2 691.55
M 1246.75 690.8
Q 1248.55 690.8 1249.75 692.05 1251.05 693.3 1251.05 695.1 1251.05 696.9 1249.75 698.1 1248.55 699.4 1246.75 699.4 1244.95 699.4 1243.65 698.1 1242.45 696.9 1242.45 695.1 1242.45 693.3 1243.65 692.05 1244.95 690.8 1246.75 690.8 Z"
        />
      </g>
      <g id="Layer0_0_MEMBER_1_MEMBER_0_FILL">
        <path
          [style.fill]="fill || '#FFC600'"
          stroke="none"
          d="
M 1614.05 532.9
Q 1615.5 534.4 1617.6 534.4 1619.65 534.45 1621.1 533 1622.65 531.6 1622.65 529.5 1622.7 527.45 1621.2 525.9 1619.8 524.45 1617.75 524.4 1615.65 524.4 1614.15 525.8 1612.7 527.3 1612.65 529.35 1612.65 531.45 1614.05 532.9 Z"
        />
      </g>
      <g id="Layer0_0_MEMBER_1_MEMBER_1_MEMBER_0_FILL">
        <path
          [style.fill]="fill || '#FF0000'"
          stroke="none"
          d="
M 1612.85 540.9
Q 1614.45 539.5 1614.45 537.4 1614.5 535.35 1612.95 533.8 1611.6 532.35 1609.55 532.3 1607.45 532.3 1605.95 533.7 1604.5 535.2 1604.45 537.25 1604.45 539.35 1605.85 540.8 1607.3 542.3 1609.4 542.3 1611.45 542.35 1612.85 540.9 Z"
        />
      </g>
      <g id="Layer0_0_MEMBER_1_MEMBER_1_MEMBER_1_FILL">
        <path
          [style.fill]="fill || '#0099FF'"
          stroke="none"
          d="
M 1625.8 542.05
Q 1627.85 542.1 1629.3 540.65 1630.85 539.25 1630.85 537.15 1630.9 535.1 1629.4 533.55 1628 532.1 1625.95 532.05 1623.85 532.05 1622.35 533.45 1620.9 534.95 1620.85 537 1620.85 539.1 1622.25 540.55 1623.7 542.05 1625.8 542.05 Z"
        />
      </g>
      <path
        id="Layer0_0_MEMBER_1_MEMBER_0_1_STROKES"
        stroke="#BABABA"
        stroke-linejoin="miter"
        stroke-linecap="square"
        stroke-miterlimit="1"
        fill="none"
        d="
M 26.919228363037064 17.662237548828102
Q 28.974765014648256 17.712343597412087 30.378546142578216 19.165419006347634 31.88259735107431 20.71870651245115 31.832462310791016 22.77305450439451 31.832462310791016 24.877508544921852 30.278276062011628 26.280477905273415 28.824359893798828 27.73355331420896 26.76882324218741 27.683447265624977 24.663151550292923 27.683447265624977 23.209235382079896 26.180265808105446 21.80545425415039 24.7271903991699 21.80545425415039 22.622736358642555 21.855589294433685 20.568388366699196 23.309505462646484 19.065206909179665 24.813556671142578 17.662237548828102 26.919228363037064 17.662237548828102 Z"
      />
      <path
        id="Layer0_0_MEMBER_1_MEMBER_1_MEMBER_0_1_STROKES"
        stroke="#BABABA"
        stroke-linejoin="miter"
        stroke-linecap="square"
        stroke-miterlimit="1"
        fill="none"
        d="
M 37.755548095703034 32.65483398437499
Q 37.755548095703034 34.76970214843749 36.15925903320294 36.17961425781249 34.762506103515534 37.63988037109374 32.71726074218759 37.58952636718749 30.62213134765625 37.58952636718749 29.175494384765443 36.07890624999999 27.778741455078034 34.61864013671874 27.778741455078034 32.50377197265624 27.828625488281205 30.43925781249999 29.275262451171784 28.92863769531249 30.771783447265534 27.51872558593749 32.866912841796875 27.51872558593749 34.91215820312482 27.56907958984374 36.259027099609284 29.02934570312499 37.805432128906205 30.59031982421874 37.755548095703034 32.65483398437499 Z"
      />
      <path
        id="Layer0_0_MEMBER_1_MEMBER_1_MEMBER_1_1_STROKES"
        stroke="#BABABA"
        stroke-linejoin="miter"
        stroke-linecap="square"
        stroke-miterlimit="1"
        fill="none"
        d="
M 24.375561523437455 36.20194091796873
Q 22.921667480468614 37.65583496093757 20.866162109374955 37.60570068359368 18.760522460937636 37.60570068359368 17.306628417968795 36.10167236328118 15.902868652343614 34.64777832031257 15.902868652343614 32.54213867187502 15.953002929687727 30.486633300781364 17.406896972656114 28.982604980468864 18.910925292968614 27.578845214843682 21.016564941406386 27.578845214843682 23.072070312500045 27.628979492187568 24.475830078125227 29.082873535156182 25.979858398437727 30.637036132812568 25.929724121093614 32.69254150390623 25.929724121093614 34.79818115234377 24.375561523437455 36.20194091796873 Z"
      />
    </defs>
    <g transform="matrix(1.5, 0, 0, 1.5, -1852.45, -1023.75)">
      <use xlink:href="#Layer0_0_MEMBER_0_FILL" />
    </g>
    <g transform="matrix( 1.0027008056640625, 0, 0, 1.0021209716796875, -1595.2,-507.85) ">
      <use xlink:href="#Layer0_0_MEMBER_1_MEMBER_0_FILL" />
      <use
        xlink:href="#Layer0_0_MEMBER_1_MEMBER_0_1_STROKES"
        transform="matrix( 0.9972991943359375, 0, 0, 0.9978790283203125, 1590.9,506.75) "
      />
    </g>
    <g transform="matrix( 0.9976806640625, 0, 0, 1.007080078125, -1572.95,-508.55) ">
      <use xlink:href="#Layer0_0_MEMBER_1_MEMBER_1_MEMBER_0_FILL" />
      <use
        xlink:href="#Layer0_0_MEMBER_1_MEMBER_1_MEMBER_0_1_STROKES"
        transform="matrix( 1.0023193359375, 0, 0, 0.9929656982421875, 1576.6,504.95) "
      />
    </g>
    <g transform="matrix( 1.002685546875, 0, 0, 1.002685546875, -1609.3,-505.9) ">
      <use xlink:href="#Layer0_0_MEMBER_1_MEMBER_1_MEMBER_1_FILL" />
      <use
        xlink:href="#Layer0_0_MEMBER_1_MEMBER_1_MEMBER_1_1_STROKES"
        transform="matrix( 0.997314453125, 0, 0, 0.997314453125, 1604.95,504.5) "
      />
    </g>
  </svg>
</ng-container>
